import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Modal, Button } from "react-bootstrap";

class TranscriptRenderer extends Component {
    render() {
        return (
            <Button 
                variant="info" 
                size="sm" 
                onClick={() => this.props.context.showTranscript(this.props.value)}
                disabled={!this.props.value}
            >
                View Transcript
            </Button>
        );
    }
}

class RecordingRenderer extends Component {
    render() {
        return (
            this.props.value ? (
                <audio controls src={this.props.value} style={{ height: '30px', width: '250px' }} />
            ) : null
        );
    }
}

class CampaignDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { field: "id", headerName: "ID", width: 80, filter: "agNumberColumnFilter" },
                { field: "contactnumber", headerName: "Phone Number", filter: "agTextColumnFilter" },
                { field: "status", headerName: "Status", filter: "agNumberColumnFilter", width: 100 },
                { 
                    field: "callstatus", 
                    headerName: "Call Status", 
                    filter: "agNumberColumnFilter", 
                    width: 120,
                    valueFormatter: params => params.value === 1 ? 'Called' : 'Pending'
                },
                { 
                    field: "successevaluation", 
                    headerName: "Success", 
                    width: 100,
                    valueFormatter: params => params.value === 1 ? 'Yes' : (params.value === 0 ? 'No' : '')
                },
                { 
                    field: "transcript", 
                    headerName: "Transcript", 
                    cellRenderer: "transcriptRenderer",
                    width: 150,
                    sortable: false,
                    filter: false
                },
                { 
                    field: "recordingurl", 
                    headerName: "Recording", 
                    cellRenderer: "recordingRenderer",
                    width: 300,
                    sortable: false,
                    filter: false
                },
                { 
                    field: "calldatetime", 
                    headerName: "Call Date", 
                    filter: "agDateColumnFilter",
                    valueFormatter: params => params.value ? new Date(params.value).toLocaleString() : ''
                }
            ],
            rowModelType: "serverSide",
            showTranscriptModal: false,
            currentTranscript: "",
            frameworkComponents: {
                transcriptRenderer: TranscriptRenderer,
                recordingRenderer: RecordingRenderer
            }
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        params.api.setServerSideDatasource({ getRows: this.getRows });
    }

    getRows = (params) => {
        fetch(`/api/getvoicecampaigndetails/${this.props.crid}`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('jwttoken')}`
            },
            body: JSON.stringify(params.request)
        })
        .then(resp => resp.json())
        .then(data => {
            if (data.rows) {
                params.successCallback(data.rows, data.lastRow);
            } else {
                params.failCallback();
            }
        })
        .catch(err => {
            console.error("Error fetching rows:", err);
            params.failCallback();
        });
    }

    showTranscript = (text) => {
        this.setState({ showTranscriptModal: true, currentTranscript: text });
    }

    render() {
        return (
            <div className="h-100 w-100 p-2">
                <div className="ag-theme-alpine" style={{ height: "calc(100vh - 200px)", width: "100%" }}>
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        rowModelType={this.state.rowModelType}
                        onGridReady={this.onGridReady}
                        context={{ showTranscript: this.showTranscript }}
                        pagination={true}
                        paginationPageSize={50}
                        cacheBlockSize={50}
                        components={this.state.frameworkComponents}
                        defaultColDef={{ 
                            resizable: true, 
                            filter: true,
                            sortable: true
                        }}
                    />
                </div>
                
                <Modal 
                    show={this.state.showTranscriptModal} 
                    onHide={() => this.setState({ showTranscriptModal: false })} 
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Call Transcript</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="p-3 bg-light rounded">
                            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
                                {this.state.currentTranscript || "No transcript available."}
                            </pre>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showTranscriptModal: false })}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default CampaignDetails;
